import React from 'react';
import { Badge } from "react-bootstrap";

const AuditStatusInfo = ({ status }) => {
  let variant = 'warning';

  switch (status) {
    case 'done':
      variant = 'success';
      break;

    case 'error':
      variant = 'danger';
      break;

    default:
      break;
  }

  return <Badge variant={ variant }>{ status }</Badge>
}

export default AuditStatusInfo;